/**
 * Like promise.race, but continues if some promises reject
 * Copied from https://github.com/Financial-Times/promise-rat-race, as it's not really maintained,
 * and isn't properly transpiling
 * @private
 */
export default function promiseRatRace(promises) {
  return new Promise((resolve, reject) => {
    let resolved = false;
    let firstError;

    Promise.all(promises.map((promise) =>
      promise
        .then((result) => {
          if (!resolved) {
            resolve(result);
            resolved = true;
          }
        }, err => {
          firstError = firstError || err;
        })))
      .then(() => {
        if (firstError && !resolved) {
          reject(firstError);
        }
      });
  });
}
